import { useAuth0 } from '@auth0/auth0-react'

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { AddMissingModal } from '../components/AddMissingHospitalOrAgencyModal'
import { AuthPromptModal, AuthPromptModalMode } from '../components/AuthPromptModal'
import { canPerformVerifiedAction } from '../utils/emailVerification'

export const useAddMissingOrganizationModal = () => {
  const { isAuthenticated, user } = useAuth0()
  const location = useLocation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalType, setModalType] = useState<'hospital' | 'agency'>('hospital')
  const [authPromptMode, setAuthPromptMode] = useState<AuthPromptModalMode | null>(null)

  const openAddMissingModal = (organizationType: 'hospital' | 'agency') => {
    if (!isAuthenticated) {
      window.location.href = `/login/redirect/${encodeURIComponent(location.pathname + location.search + location.hash)}`
      return
    }
    if (!canPerformVerifiedAction(isAuthenticated, user)) {
      setAuthPromptMode('verify-email')
      return
    }
    setModalType(organizationType)
    setIsModalOpen(true)
  }

  const handleModalClose = () => setIsModalOpen(false)

  useEffect(() => {
    if (!isModalOpen) return

    document.body.style.overflow = 'hidden'
    const pageRoot = document.getElementById('page-root')
    if (pageRoot) pageRoot.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = ''
      if (pageRoot) pageRoot.style.overflow = 'auto'
    }
  }, [isModalOpen])

  const addMissingModal = (
    <>
      {authPromptMode && (
        <AuthPromptModal
          returnTo={location.pathname + location.search + location.hash}
          mode={authPromptMode}
          onClose={() => setAuthPromptMode(null)}
        />
      )}
      {isModalOpen && <AddMissingModal isOpen={isModalOpen} onClose={handleModalClose} type={modalType} />}
    </>
  )

  return {
    addMissingModal,
    openAddMissingModal,
  }
}
